if (!customElements.get('hanmade-ribbon')) {
  customElements.define('hanmade-ribbon', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const button = this.querySelector('button');
      const preference = matchMedia('(prefers-reduced-motion: reduce)');
      const refresh = () => {
        button.hidden = preference.matches;
        if (preference.matches) this.setAttribute('data-paused', '');
        button.setAttribute('aria-label', this.hasAttribute('data-paused') ? 'Resume moving ribbon' : 'Pause moving ribbon');
        button.firstElementChild.textContent = this.hasAttribute('data-paused') ? '▷' : 'Ⅱ';
      };
      button.addEventListener('click', () => { this.toggleAttribute('data-paused'); refresh(); }, options);
      preference.addEventListener('change', refresh, options);
      refresh();
      this.setAttribute('data-ready', '');
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
